import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=d47213c2&scoped=true&"
import script from "./Books.vue?vue&type=script&lang=ts&"
export * from "./Books.vue?vue&type=script&lang=ts&"
import style0 from "./Books.vue?vue&type=style&index=0&id=d47213c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47213c2",
  null
  
)

export default component.exports